/** @format */

import { useState } from 'react'
import { useDebounce, useWindowSize as useReactUseWindowSize } from 'react-use'
import variable from 'src/static/styles/var'

export interface UseWindowSizeOptions {
  /** 在 pagePadding 之外额外扣减的高度（px），默认 0 */
  offset?: number
  /** resize 防抖时间（ms），默认 300 */
  debounceMs?: number
  /** 容器最小高度，默认 0 */
  minHeight?: number
}

const calcContainerHeight = (winHeight: number, offset: number, minHeight: number) =>
  Math.max(winHeight - parseInt(variable.pagePadding, 10) - offset, minHeight)

/**
 * 监听窗口尺寸变化（防抖），并计算可用容器高度：
 * containerHeight = windowHeight - pagePadding - offset
 */
const useWindowSize = (options: UseWindowSizeOptions = {}) => {
  const { offset = 0, debounceMs = 300, minHeight = 0 } = options
  const { width, height } = useReactUseWindowSize()
  const [containerHeight, setContainerHeight] = useState(() =>
    calcContainerHeight(typeof window !== 'undefined' ? window.innerHeight : 0, offset, minHeight)
  )

  useDebounce(
    () => {
      setContainerHeight(calcContainerHeight(height, offset, minHeight))
    },
    debounceMs,
    [height, offset, minHeight]
  )

  return {
    width,
    height,
    containerHeight
  }
}

export default useWindowSize
